/* eslint-disable no-redeclare */
import { z } from 'zod';

export const AdServer = z.enum(['FeaturedAds', 'AdButler', 'MediaAlpha']);
export type AdServer = z.infer<typeof AdServer>;

export const CostModel = z.enum(['CPC', 'CPA']);
export type CostModel = z.infer<typeof CostModel>;

export const HtmlText = z.string();
export type HtmlText = z.infer<typeof HtmlText>;

export const Integer = z.number().int();
export type Integer = z.infer<typeof Integer>;

export const NonEmptyText = z.string().min(1);
export type NonEmptyText = z.infer<typeof NonEmptyText>;

export const Url = z.string().url();
export type Url = z.infer<typeof Url>;

export const FeaturedAd = z.object({
  id: NonEmptyText,
  logo: Url,
  title: NonEmptyText,
  content: HtmlText,
  provider: z.object({
    id: Integer.optional(),
    name: NonEmptyText,
    displayUrl: z.string(),
  }),
  link: Url,
  creativeId: Integer,
  groupId: Integer.optional(),
  campaignId: Integer.optional(),
  campaignName: NonEmptyText.optional(),
  dealType: CostModel,
  cpc: z.number(),
  adsSource: AdServer,
  searchMethod: z.string().optional(),
  segmentationFit: z.string().optional(),
  uniqueClickId: z.string().optional(),
});

export type FeaturedAd = z.infer<typeof FeaturedAd>;
